import { getAccountDetailsTokenCookie, isHomeOfficeUser } from '../../utils';
import {axiosInstancePensions} from './wrapper/apiwrapper';
import {v4 as uuidv4} from 'uuid';
  
  
export const NetworkManager ={
  // Get Tax Document List API endpoint.
  getTaxDocumentListData: (token) => {
      const xoacorrelationId = uuidv4();
      return axiosInstancePensions.get(`participants/participant/tax-documents/1099R/years`, {
          headers: {
            'X-OA-CorrelationID': xoacorrelationId,
            Authorization: `Bearer ${token}`,
            ...(isHomeOfficeUser() && {
              'x-oa-statetoken': getAccountDetailsTokenCookie(),
            }),
          },
      });
  },
  getTaxDocument: (token, formId) => {
    const xoacorrelationId = uuidv4();
    return axiosInstancePensions.get(
      `participants/participant/tax-documents/1099R/estatement/${formId}`,
      {
        headers: {
          'X-OA-CorrelationID': xoacorrelationId,
          Authorization: `Bearer ${token}`,
          ...(isHomeOfficeUser() && {
            'x-oa-statetoken': getAccountDetailsTokenCookie(),
          }),
        },
      }
    );
  },
  getPensionVerificationListData: (planNumber: string | null, token: string) => {
    const xoacorrelationId = uuidv4();
    return axiosInstancePensions.get(`plans/${planNumber}/participants/participant/pvl-documents/search`, {
        headers: {
          'X-OA-CorrelationID': xoacorrelationId,
          Authorization: `Bearer ${token}`,
          'businessUnit': 'prt',
          'documentType': 'reviewableDoc',
          ...(isHomeOfficeUser() && {
            'x-oa-statetoken': getAccountDetailsTokenCookie(),
          }),
        },
    });
  },
  getPensionVerificationDocument: (planId, documentId, token) => {
    const xoacorrelationId = uuidv4();
  
    return axiosInstancePensions.get(
      `plans/${planId}/participants/participant/pvl-documents/${documentId}`,
      {
        headers: {
          'X-OA-CorrelationID': xoacorrelationId,
          Authorization: `Bearer ${token}`,
          businessUnit: 'prt',
          documentType: 'reviewableDoc',
          ...(isHomeOfficeUser() && {
            'x-oa-statetoken': getAccountDetailsTokenCookie(),
          }),
        },
      }
    );
  }, 
  postRegeneratePensionVerification: (planNumber: string | null, token: string) => {
    const xoacorrelationId = uuidv4();
    return axiosInstancePensions.post(`plans/${planNumber}/participants/participant/pvl`, { isRegenerateFlag: true }, {
        headers: {
          'X-OA-CorrelationID': xoacorrelationId,
          Authorization: `Bearer ${token}`,
          ...(isHomeOfficeUser() && {
            'x-oa-statetoken': getAccountDetailsTokenCookie(),
          }),
        },
    });
  },
};
